import {FloatingWindowsContainerScopeContext, reactCreateMemo } from '@wix/devzai-utils-react';
import React, {useRef} from 'react';
import {classes, style} from './doppe-viewer-lightbox-modal-panel.st.css';
import {
    bymoPageStyleGetStyleScopeClassName,
    BymoPageStyleScopeContext
} from '../bymo-page-style/bymo-page-style';
import {
    DoppeViewerHorizontalButton,
    DoppeViewerHorizontalButtonPriority
} from '../doppe-viewer-horizontal-button/doppe-viewer-horizontal-button';
import {DoppeViewerAppIconDismissMedium} from '../doppe-viewer-icons/doppe-viewer-icons';
import {FlexLayout} from '@wix/devzai-common-client';
import {BymoPageStyleScope} from "../../client-server-common";

export const DoppeViewerLightboxModalPanel = reactCreateMemo(function DoppeViewerLightboxModalPanel(props: DoppeViewerLightboxModalPanel.Props) {
    const {
        children,
        onSubmit,
        dismissButtonCallback,

        className,
        ...htmlAttributes
    } = props;

    const rootRef = useRef<HTMLDivElement>(null)

    return (
        <FloatingWindowsContainerScopeContext.Provider
            value={() => {
                return {
                    zIndex: 1,
                    targetContainer: rootRef.current
                }
            }}
        >
            <BymoPageStyleScopeContext.Provider
                value={BymoPageStyleScope.Popup}
            >
                <div
                    {...htmlAttributes}
                    className={style(classes.root, {}, className, bymoPageStyleGetStyleScopeClassName(BymoPageStyleScope.Popup))}
                    ref={rootRef}
                    onSubmit={event => {
                        event.preventDefault();

                        onSubmit?.(event);
                    }}
                >
                    {
                        dismissButtonCallback ?
                            <div
                                className={style(classes.headerRow, {}, FlexLayout.column.alignToEnd)}
                            >
                                <DoppeViewerHorizontalButton
                                    className={style(classes.dismissButton, {hidden: dismissButtonCallback === undefined})}
                                    prefixIcon={DoppeViewerAppIconDismissMedium}
                                    textual={true}
                                    priority={DoppeViewerHorizontalButtonPriority.Secondary}
                                    onClick={() => {
                                        dismissButtonCallback?.();
                                    }}
                                />
                            </div>
                            :
                            null
                    }

                    {children}
                </div>
            </BymoPageStyleScopeContext.Provider>
        </FloatingWindowsContainerScopeContext.Provider>
    )
});

export namespace DoppeViewerLightboxModalPanel {

    export interface Props extends React.HTMLAttributes<any> {
        dismissButtonCallback?: () => void;
    }
}
